module.exports = __webpack_public_path__ + "6f2b500561d09e35166d9492f2c86d5b.ttf";